import React from 'react';
import loadable from '@loadable/component';
import Container from 'app/shared/core/Container';
import SkeletonListingCardGroup from 'app/shared/modules/skeleton/SkeletonListingCardGroup';

const AreaListingsContainer = loadable(
  () =>
    import(
      /* webpackChunkName: "AreaListingsContainer.loadable" */ 'app/shared/wrappers/AreaListingsContainer/component'
    ),
  {
    fallback: (
      <Container>
        <SkeletonListingCardGroup count={20} />
      </Container>
    ),
  },
);

class LoadableAreaListingsContainer extends React.Component {
  render() {
    return <AreaListingsContainer {...this.props} />;
  }
}

export default LoadableAreaListingsContainer;
